module.exports = __webpack_public_path__ + "img/075-antigua-and-barbuda.2bf1a774.svg";